<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>Lista produktów</h1>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <div md="12">
                  <input
                    id="searchInput"
                    v-model="searchValue"
                    @change="searchProduct()"
                    type="text"
                    placeholder="Wyszukiwarka"
                  />
                </div>
                <br />

                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Nr Katalogowy</th>
                          <th scope="col">Nr Oryginalny</th>
                          <th scope="col">Nazwa</th>
                          <th scope="col">
                            Cena
                            <br />PLN netto
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          @click="showProductDetails(item.id)"
                          class="B2BproductRow"
                          v-for="item in ordersData"
                          v-bind:key="item.id"
                        >
                          <td scope="col">{{ item.nr_kat }}</td>
                          <td scope="col">{{ item.nr_oryginalny }}</td>
                          <td scope="col">{{ item.nazwa }}</td>
                          <td scope="col" align="right">{{ item.cena }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import usersData from "./users/UsersData";
import CTableWrapper from "./base/Table.vue";

export default {
  name: "b2bproducts",
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CTableWrapper,
  },
  created() {
    this.mthFillProductsData("");

    console.log("should be:");
    console.log(this.ordersData);
  },
  data() {
    return {
      searchValue: "",
      ordersData: [],
    };
  },
  methods: {
    mthFillProductsData(like) {
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bproductsmainpage?like=" +
        like +
        "&limit=100";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          console.log("api response:");
          console.log(response.data);
          that.ordersData = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      console.log(array.length);
      return false;
    },

    getShuffledOrdersData() {
      return this.shuffleArray(this.ordersData.slice(0));
    },

    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
    searchProduct() {
      this.mthFillProductsData(this.searchValue);
    },
    showProductDetails(id) {
      this.$router.replace("/b2bproductDetails/" + id);
    },
  },
};
</script>

<style>
@import "./styles/products.css";
</style>

